import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRoles, deleteRole, toggleRoleStatus } from '../../store/role/role.action';
import Table from '../../extra/Table';
import Pagination from '../../extra/Pagination';
import Button from '../../extra/Button';
import ToggleSwitch from '../../extra/ToggleSwitch';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Iconb from '../../extra/Iconb';
import { permissionError, warning } from '../../../util/Alert';
import RoleDialogue from './RoleDialogue';
import PermissionViewDialogue from './PermissionViewDialogue';
import { usePermission } from '../../../hooks/usePermission';

const Roles = () => {
  const dispatch = useDispatch();

  const { can } = usePermission();
  const canCreate = can("Access Roles", "Create");
  const canDelete = can("Access Roles", "Delete");
  const canEdit = can("Access Roles", "Edit");

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const { roles, totalRoles } = useSelector((state) => state.roles);
  const { dialogueType } = useSelector((state) => state.dialogue);
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getRoles(page, size));
  }, [dispatch, page, size]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleToggleStatus = (id) => {
    if (!hasPermission) return permissionError();
    dispatch(toggleRoleStatus(id));
  };


  const handleDelete = (id) => {
    warning("Delete").then((res) => {
      if (!res) return;
      if (!hasPermission) return permissionError();
      dispatch(deleteRole(id));
    });
  };

  const roleTableColumns = [
    {
      Header: 'No',
      body: 'no',
      Cell: ({ index }) => (
        <span>{(page - 1) * size + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: 'Role Name',
      body: 'name',
      Cell: ({ row }) => <span className="text-capitalize">{row?.name}</span>,
    },
    {
      Header: 'Permissions',
      body: 'permissions',
      Cell: ({ row }) => (
        <span>{row?.permissions?.length || 0} Modules</span>
      ),
    },
    ...(canEdit ? [
{
      Header: 'Status',
      body: 'isActive',
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isActive}
          onClick={() => handleToggleStatus(row?._id)}
        />
      ),
    }
    ] : []),
    
    ...(canEdit ? [
{
      Header: "Edit",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
          style={{ borderRadius: "50px", margin: "auto", height: "45px", width: "45px", color: "#160d98" }}
          isImage={true}
          onClick={() => dispatch({ type: "OPEN_DIALOGUE", payload: { type: 'role', data: row } })}
        />
      ),
    }
    ] : []),
    
    ...(canDelete ? [
    {
      Header: "Delete",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter killbtn userBtn fs-5`}
          btnIcon={<DeleteIcon sx={{ color: '#FF4C51' }} />}
          style={{ borderRadius: "50px", margin: "auto", height: "45px", width: "45px", color: "#160d98", padding: "0px" }}
          isImage={true}
          isDeleted={true}
          onClick={() => handleDelete(row?._id)}
        />
      ),
    }] : []),
    {
      Header: "Info",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<InfoOutlined sx={{ color: '#737272' }} />}
          style={{ borderRadius: "50px", margin: "auto", height: "45px", width: "45px", color: "#160d98", padding: "0px" }}
          isImage={true}
          isDeleted={true}
          onClick={() => dispatch({ type: "OPEN_DIALOGUE", payload: { type: 'viewPermission', data: row } })}
        />
      ),
    },

  ];

  return (
    <>
      {dialogueType === 'role' && <RoleDialogue page={page} size={size} />}
      {dialogueType === 'viewPermission' && <PermissionViewDialogue />}
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Access Role</div>
          <div className="sellerMain">
            <div className="tableMain mt-2 categoryTable">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-12">
                    {canCreate && (
                      <Button
                        newClass={`whiteFont`}
                        btnColor={`btnBlackPrime `}
                        btnIcon={`fa-solid fa-plus `}
                        btnName={`Add`}
                        onClick={() => {
                          dispatch({ type: "OPEN_DIALOGUE", payload: { type: 'role' } });
                        }}
                        style={{ borderRadius: "5px", padding: "8px 32px", background: "#b93160" }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <Table
                data={roles}
                mapData={roleTableColumns}
                serverPerPage={size}
                serverPage={page}
                type={'server'}
                loading={loading}
                shimmer={true}
              />
              <Pagination
                component="div"
                count={totalRoles}
                type={"server"}
                onPageChange={handlePageChange}
                serverPerPage={size}
                totalData={totalRoles}
                serverPage={page}
                setCurrentPage={setPage}
                onRowsPerPageChange={handleRowsPerPage}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};


export default Roles;